import React, { Component } from "react";
import { Card, CardBody, Col, Row, Label, Alert, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { BeatLoader } from 'react-spinners'
import getGroupSelection from "../../../helpers/assessment/getGroupSelection";
import filterGroupData from "../../../helpers/assessment/filterGroupData";
import getActiveGroupDataType from "../../../helpers/assessment/getActiveGroupDataType";
import { SearchDropdown, SearchDropdownStudent } from "./";
import Select from "react-select";
import requestGroupUAUpdate from "../../../helpers/assessment/requestGroupUAUpdate";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux'
import * as assessmentActionCreators from '../../../redux/modules/assessment'
import processGroupUAUpdate from "../../../helpers/assessment/processGroupUAUpdate";
/*
Slim selection bar based on role

Bring selection bar over to the other segments

*/

class AssessSelectorBar extends Component {
  refreshGUA = () => {
    const { 
      selectedGroupUA, 
      assessmentId, 
      fetchingGroupUAsSuccess,
      isRefreshing,
      refreshingSuccess,
      refreshingError,
      groupUAs,
      year
    } = this.props
    const schoolYear = Number(year.split('sy')[1])
    console.log(year)
    if (!groupUAs) return
    isRefreshing()
    return requestGroupUAUpdate(selectedGroupUA, assessmentId, schoolYear)
      .then(res => {
        const actions = {
          fetchingGroupUAsSuccess,
          refreshingSuccess,
        }
        processGroupUAUpdate(res, groupUAs, selectedGroupUA, schoolYear, assessmentId, actions, true)
      })
      .catch(err => {
        refreshingError(err)
        console.log(err)
      })
  }

  render() {
    const {
      sm,
      md,
      lg,
      xl,
      selectedGroupUA,
      groupData,
      groupUAs,
      selectGroupUA,
      assessmentId,
      selectStudent,
      selectedStudent,
      role,
      itemNumber,
      user,
      userAssessment,
      isAssessmentInitializing,
      updatingGUA,
      refreshingGUA,
      year
    } = this.props
    const { refreshGUA } = this
    const groupTypesByRole = {
      "Super Administrator": ["School District", "School", "Teacher", "Class"],
      "District Admin": ["School District", "School", "Teacher", "Class"],
      "School Admin": ["School", "Teacher", "Class"],
      Teacher: ["Teacher", "Class"]
    };
     
    const groupTypes = groupTypesByRole[role];

    const groupKeys = {
      "School District": "districts",
      School: "schools",
      Teacher: "educators",
      Class: "classes",
      Student: "students"
    };
    const backtrack = {
      School: "School District",
      Teacher: "School",
      Class: "Teacher",
      Student: "Class"
    };
    const filterKeys = {
      "School District": "district",
      School: "school",
      Teacher: "teacher"
    };
    const selectedGroupDropDown =  groupUAs && groupUAs[selectedGroupUA] && groupUAs[selectedGroupUA];
    const selectedDistricts = (selectedGroupDropDown!==undefined
      && selectedGroupDropDown!==null
       && selectedGroupDropDown.district
        && selectedGroupDropDown.district!==null)
         ? selectedGroupDropDown.district : null;
    
    let selectedSchool = null;
    let selectedClass = null;
    let selectedTeacher = null;
    if(selectedGroupDropDown !== undefined && selectedGroupDropDown!==null && groupTypes!==null && selectedGroupDropDown.groupType!==null && selectedGroupDropDown.groupType==="Class")
    {
       selectedClass = selectedGroupDropDown.id?selectedGroupDropDown.id:null;
    }else if(selectedGroupDropDown !== undefined &&  selectedGroupDropDown!==null && groupTypes!==null && selectedGroupDropDown.groupType==="School")
    {
       selectedSchool = selectedGroupDropDown.id?selectedGroupDropDown.id:null;
    }else if(selectedGroupDropDown !== undefined && selectedGroupDropDown!==null && groupTypes!==null && selectedGroupDropDown.groupType==="Teacher")
    {
       selectedTeacher = selectedGroupDropDown.id?selectedGroupDropDown.id:null;
    }
     selectedSchool = selectedGroupDropDown!==null && selectedGroupDropDown !== undefined && selectedGroupDropDown.school?selectedGroupDropDown.school:selectedSchool
     selectedTeacher = selectedGroupDropDown!==null && selectedGroupDropDown !== undefined && selectedGroupDropDown.teacher?selectedGroupDropDown.teacher:selectedTeacher

    //const selectedGroupType = (selectedGroupDropDown.groupType) ? selectedGroupDropDown.districts : null;
    //    const selection = getGroupSelection(groupUAs, selectedGroupUA, user)
    const groupDataType = getActiveGroupDataType(groupData, selectedGroupUA);
    const selection = getGroupSelection(
      groupData,
      selectedGroupUA,
      user,
      groupDataType
    );
    let inputSelects = [];
    const placeholder = "";
    const selectWidthControl = {
      minWidth: "190px"
    };
    const rightDividerCss = {
      borderRight: "1px solid #efeff0"
    };
    let studentInputSelect = (
      <Col
        xl="2"
        lg="2"
        md="6"
        sm="12"
        key={`StudentInputCol`}
        style={selectWidthControl}
      >
        <Label>Students</Label>
        <Select
          placeholder={placeholder}
          isDisabled={true}
          options={inputSelects}
        />
      </Col>
    );

    if (selection) {
      groupTypes.forEach(groupType => {
        let disabled = false;
        const thisGroupData = groupData[groupKeys[groupType]];
        const filteredGroupData = filterGroupData(
          thisGroupData,
          selection,
          groupType
        );
        if (role !== "Super Administrator" && groupType === "School District") {
          const group = filteredGroupData[0];
          return inputSelects.push(
            <Col
              xl="2"
              lg="2"
              md="6"
              sm="12"
              key={`${groupType}InputCol`}
              style={rightDividerCss}
            >
              <Label>{`${groupType}:`}</Label>
              <p>
                <b>{group.name}</b>
              </p>
            </Col>
          );
        }

        if(role == 'Teacher' && filteredGroupData[0] && filteredGroupData[0].teacher) {
          filteredGroupData.filter((teacher) => {
            if (!user) return false
            return teacher.id == user.id;
          })
        }

        {
         ((groupType === "School" && role === "School Admin") || (groupType === "Teacher" && role === "Teacher")) 
            ? inputSelects.push(
                <Col
                  xl="2"
                  lg="2"
                  md="6"
                  sm="12"
                  key={`${groupType}InputCol`}
                  style={rightDividerCss}
                >
                  <Label>{`${groupType}:`}</Label>
                  <p>
                    <b>
                    {role==="School Admin"?
                    filteredGroupData[0].name
                    :
                    filteredGroupData[0].fullName
                  }
                    
                    
                    </b>
                  </p>
                </Col>
              )
            : inputSelects.push(
                <SearchDropdown
                  key={`${groupType}InputCol`}
                  groupType={groupType}
                  itemNumber={itemNumber}
                  selectGroupUA={selectGroupUA}
                  selection={selection}
                  disabled={disabled}
                  filteredGroupData={filteredGroupData}
                  selectedDistricts = {selectedDistricts}
                  selectedSchool = {selectedSchool}
                  selectedClass = {selectedClass}
                  selectedTeacher = {selectedTeacher}
                  year={year}
                  role={role}
                />
              );
        }
      });

      if (selection.Class && groupData) {
        studentInputSelect = (
          <SearchDropdownStudent
            Class={selection.Class}
            gDataKey={groupKeys.Student}
            groupData={groupData}
            itemNumber={itemNumber}
            selectGroupUA={selectGroupUA}
            selectStudent={selectStudent}
            selectedStudent={selectedStudent}
            userAssessment={userAssessment}
            isAssessmentInitializing={isAssessmentInitializing}
            year={year}
          />
        );
      }
    }

    let bar = (
      <Row>
        {inputSelects}
        {studentInputSelect}
        <Col
          xl="2"
          lg="2"
          md="6"
          sm="12"
          
        > 
        
         
          {/* <BounceLoader loading={updatingGUA} sizeUnit={'px'} color={'#00C1AB'} size={30}/> */}
        </Col>
        <div className="refresh-gua-wrapper"><div className={`refresh-gua-button ${updatingGUA || refreshingGUA ? 'active' : ''}`} onClick={() => refreshGUA()}></div></div>
      </Row>
    );
    if (!selection) {
      bar = (
        <Alert color="warning">
          No data is available to view on this test. Add classes and students.
          Once at least one of your students takes this test, data will be
          available.
        </Alert>
      );
    }
    let uploadLinkURL = "";

    const showUploadLink = !!(
      groupData &&
      groupData.schools &&
      groupData.schools[selectedGroupUA] &&
      role === "Super Administrator"
    );
    if (showUploadLink) {
      const ROOT = "/assessment/upload/school/";
      const schoolYear = Number(year.split('sy')[1])
      uploadLinkURL = `${ROOT}${selectedGroupUA}?a=${assessmentId}&sy=${schoolYear}`;
    }
    const style_col = {
      //   marginTop: '-1.3%',
      // marginLeft: '-1.8%',
      // marginBottom: '2%',
      padding: "0px"
    };
    const style_div = {
      backgroundColor: "#f4f8fb"
      // paddingBottom: '26px'
    };
    return (
      <Col
        sm={sm ? sm : "12"}
        md={md ? md : "12"}
        lg={lg ? lg : "12"}
        xl={xl ? xl : "12"}
        style={style_col}
      >
        <Card>
          <CardBody style={style_div} className="assess-selector-bar">
            {bar}
            {showUploadLink && (
              <Link to={uploadLinkURL}>
                <Button className={"ml-2"}>Upload CSV</Button>
              </Link>
            )}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default connect(
  (state) => ({
    refreshingGUA: state.assessment.refreshingGUA,
    refreshingError: state.assessment.refreshingError,
  }),
  (dispatch) => bindActionCreators({
    fetchingGroupUAsSuccess: assessmentActionCreators.fetchingGroupUAsSuccess,
    isRefreshing: assessmentActionCreators.isRefreshing,
    refreshingSuccess: assessmentActionCreators.refreshingSuccess,
    refreshingError: assessmentActionCreators.refreshingError,
  }, dispatch)
)(AssessSelectorBar)


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessSelectorBar/AssessSelectorBar.js